import { render } from "./RepaymentPage.vue?vue&type=template&id=3a0b88d6&ts=true"
import script from "./RepaymentPage.vue?vue&type=script&lang=ts"
export * from "./RepaymentPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__